











































































import Vue from "vue";
import { UseToast, ToastType } from "./toast.state";
import { ref } from "@vue/composition-api";
import { debounceVar, emptyFn } from "@/fp";

export default Vue.extend({
  setup() {
    const { listenForToastMsgs } = UseToast();
    const isShow = ref(false);
    const msg = ref("");
    const duration = ref(2000);
    const type = ref(ToastType.OFFLINE as ToastType);
    const actionName = ref("");
    let action = emptyFn();

    const hide = debounceVar(() => duration.value)(
      () => (isShow.value = false)
    );

    const toasts = {
      success: {
        icon: "CheckCircle",
        title: "Success",
      },
      alert: {
        icon: "Error",
        title: "Error",
      },
      info: {
        icon: "Info",
        title: "Info",
      },
      offline: {
        icon: "Offline",
        title: "You are offline",
      },
    };

    listenForToastMsgs((config) => {
      isShow.value = true;
      msg.value = config.msg;
      type.value = config.type;
      duration.value = config.duration || 2000;
      if (config.action) {
        actionName.value = config.action.name;
        action = config.action.onClick;
      } else {
        actionName.value = "";
        action = emptyFn();
      }
      hide();
    });

    const close = () => {
      duration.value = 0;
      hide();
    };

    const onAction = () => {
      close();
      action && action();
    };

    return {
      isShow,
      toasts,
      duration,
      msg,
      type,
      close,
      actionName,
      action,
      onAction,
    };
  },
});
